<style lang="scss">
  .schedule{
    ul, li{
      list-style: none;
    }

    ul{
      padding-left: 0;
    }

    .task-list-item{
      p{
        color: black !important;
      }

      &:hover{
        background-color: #B1B4B6 !important;
      }
    }
  }
</style>

<template>
  <div cy="calendar-slots">
    <Schedule
      v-if="tasksReady"
      :color="['#E6E6E6']"
      :time-ground="['00:00', '24:00']"
      :week-ground="weekdays"
      :task-detail="tasks"
      @slot-deactivate="$emit('slot-deactivate', $event)"
      @slot-activate="$emit('slot-activate', $event)"
      @slot-edit="$emit('slot-edit', $event)"
    />
  </div>
</template>

<script>
  import BookingSlotService from '@/services/BookingSlotService';
  import Schedule from '@/components/schedules/Schedule.vue';

  export default {
    components: {
      Schedule,
    },
    props: {
      slots: Array,
    },
    data() {
      return {
        weekdays: BookingSlotService.getWeekdays(),
        hours: BookingSlotService.getHours(),
        tasksReady: false,
        tasks: [],
      };
    },
    mounted() {
      this.generateTasksFromSlots();
    },
    methods: {
      generateTasksFromSlots() {
        this.tasksReady = false;
        const newTasks = [];

        this.weekdays.forEach(day => {
          const daySlots = this.getSlotsForDay(this.slots, day);
          const dayTasks = [];

          daySlots.forEach(slot => {
            dayTasks.push({
              dateStart: slot.slot_begin,
              dateEnd: slot.slot_end,
              slot,
            });
          });
          newTasks.push(dayTasks);
        });

        this.tasks = newTasks;
        this.tasksReady = true;
      },
      getSlotsForDay(slots, day) {
        return slots.filter(slot => slot.day_of_week === day);
      },
    },
  };
</script>
